/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema } from '../schema';
import { Account, accountSchema } from './account';

export interface Data12 {
  account: Account;
}

export const data12Schema: Schema<Data12> = object({
  account: ['Account', lazy(() => accountSchema)],
});
